"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openStreamAtVeryTop = exports.matchListPageChange = exports.setMinAndMaxPages = exports.paginationInitialized = exports.dropPaginationState = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var constants_1 = require("./constants");
var getHistory = core_1.default.services.getHistory;
var dropPaginationState = function () { return ({
    type: constants_1.DROP_STATE,
    payload: {},
}); };
exports.dropPaginationState = dropPaginationState;
var paginationInitialized = function () { return ({
    type: constants_1.PAGINATION_ENABLED,
    payload: {},
}); };
exports.paginationInitialized = paginationInitialized;
var setMinAndMaxPages = function () { return ({
    type: constants_1.SET_MIN_MAX_PAGES,
    payload: {
        listType: getHistory().location.pathname,
    },
}); };
exports.setMinAndMaxPages = setMinAndMaxPages;
var matchListPageChange = function (page, isVisible, bottom) { return ({
    type: constants_1.CHANGE_PAGE_NUMBER,
    payload: {
        listType: getHistory().location.pathname,
        page: page,
        isVisible: isVisible,
        bottom: bottom,
    },
}); };
exports.matchListPageChange = matchListPageChange;
var openStreamAtVeryTop = function () { return ({
    type: constants_1.OPEN_STREAM_AT_VERY_TOP,
    payload: {},
}); };
exports.openStreamAtVeryTop = openStreamAtVeryTop;
//# sourceMappingURL=actions.js.map